import { NETWORK_NAME_PER_CHAIN_ID, SUPPORTED_CHAINS, SupportedChainId } from '@/constants/chain';

import { chainAvatarRadius } from '@/ui/Avatars/ChainAvatar';
import { chainAvatarSvg } from '@/ui/Avatars/ChainAvatar/chainAvatarLogos';
import { Multiselect } from '@/ui/Multiselect';

const DEFAULT_NETWORKS = SUPPORTED_CHAINS.map((chain) => chain.id);

type NetworkFilterProps = {
  value: string[];
  onChange: (selected: string[]) => void;
  onDropdownClose?: () => void;
  networks?: number[];
};

export const NetworkFilter = ({
  value,
  onChange,
  onDropdownClose,
  networks = DEFAULT_NETWORKS,
}: NetworkFilterProps) => {
  const filterItems = networks.map((network) => ({
    value: `${network}`,
    label: NETWORK_NAME_PER_CHAIN_ID[network],
    icon: chainAvatarSvg[network as SupportedChainId],
    iconAlt: `${NETWORK_NAME_PER_CHAIN_ID[network]} logo`,
    iconRadius: chainAvatarRadius,
  }));

  return (
    <Multiselect
      items={filterItems}
      value={value}
      onChange={onChange}
      onDropdownClose={onDropdownClose}
      title="Networks"
      showSelectAllButton={true}
      modal={true}
      itemsLayout="two-columns"
      label={{ default: 'All networks', entity: 'networks' }}
      multiselect={true}
    />
  );
};
